module.exports = __webpack_public_path__ + "6ec9e6c527758a98e5da6c55bb1becec.png";